/** Anchor id on ProfileCreateEvent — scroll target for the advertise-event form. */
export const ADVERTISE_EVENT_FORM_ID = "advertise-event-form";

export const CREATE_EVENT_PATH = "/profile/create-event";

export const CREATE_EVENT_ADVERTISE_LINK = `${CREATE_EVENT_PATH}#${ADVERTISE_EVENT_FORM_ID}`;

/** Append form anchor for internal create-event links (mobile auto-scroll). */
export const withAdvertiseEventFormAnchor = (url) => {
  if (!url || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) return trimmed;
  const [pathOnly] = trimmed.split("#");
  const path = pathOnly.trim();
  if (!path.includes(CREATE_EVENT_PATH)) return trimmed;
  return `${path}#${ADVERTISE_EVENT_FORM_ID}`;
};
